<template>
  <div>
    <v-container fluid class="content-wrapper">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Pending Registration
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <table-pending-registration
              ref="table"
              :search="search"
              :search-attributes="[]"
              :url-api="'/api/v1/auth-user'"
            >
            </table-pending-registration>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TablePendingRegistration from '@/components/admin/pending-registration/TablePendingRegistration';

export default {
  name: 'PendingRegistration',
  components: {
    TablePendingRegistration,
  },
  data: () => ({
    search: {},
    tableKey: 0,
  }),
};
</script>

<style scoped></style>
